<div *ngVar="loading$ | async as loading" class="compare-dropdown flex items-center">
  <span class="mr-1 text-sm">Compare to</span>
  <ng-select
    *ngVar="snapshots$ | async as snapshots"
    id="compare-snapshot-dropdown"
    class="compare-dropdown w-60 text-sm"
    placeholder="Select a budget snapshot"
    bindValue="value"
    appendTo="body"
    [clearable]="true"
    [searchable]="false"
    [loading]="loading"
    [formControl]="formControl"
    [items]="snapshots"
    [groupBy]="groupByFn"
  >
    <ng-template let-item="item" let-index="index" ng-option-tmp>
      <div>
        <div class="flex justify-between">
          <p
            class="w-40 overflow-hidden text-ellipsis"
            [attr.data-pendo-id]="
              item.snapshot_type === BUDGET_SNAPSHOT_USER_CREATED
                ? 'manual-snap-compare'
                : 'auto-snap-compare'
            "
            [auxTooltip]="item.label"
          >
            {{ item.label }}
          </p>
          @if (item.value) {
            <div class="flex items-center">
              @if (item.snapshot_type === BUDGET_SNAPSHOT_USER_CREATED) {
                <aux-icon
                  name="Pencil"
                  class="mr-1 text-aux-blue"
                  (click)="editSnapshot($event, item)"
                />
              }
              <aux-icon
                name="Trash"
                class="text-aux-red-dark"
                (click)="deleteSnapshot($event, item)"
              />
            </div>
          }
        </div>
        <p class="text-aux-gray-darkest">{{ item.create_date | date: 'YYYY-MM-dd' }}</p>
      </div>
    </ng-template>
  </ng-select>
</div>
